// removed by extract-text-webpack-plugin
module.exports = {"solo":"position__solo___iTu-P borderRadius-s","end":"position__end___2mhEK borderRadiusRight-s","left":"position__left___1m8MA borderRadiusLeft-s","right":"position__right___11xul borderRadiusRight-s","middle":"position__middle___2yEMj"};


//////////////////
// WEBPACK FOOTER
// ./packages/marvel-ui-toolbar/ToolbarButton/style/position.css
// module id = 257
// module chunks = 0 13